import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@pps/ui/components/ui/button';
import { cn } from '@pps/ui/lib/utils';
import { estaInstaladoComoApp, podeVoltarNoApp } from '@/lib/voltar-no-app';

/**
 * "Voltar" no cabeçalho: aparece quando há uma tela anterior DENTRO do app
 * (lib/voltar-no-app.ts). No celular sempre; no desktop só com o CRM
 * instalado como app (no navegador comum o voltar dele já existe).
 */
export function VoltarNoCabecalho() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  // `useLocation` re-renderiza a cada navegação, e é aí que o idx muda.
  useLocation();
  if (typeof window === 'undefined' || !podeVoltarNoApp(window.history.state)) return null;

  return (
    <Button
      variant="ghost"
      size="icon"
      className={cn('h-11 w-11 shrink-0', !estaInstaladoComoApp() && 'md:hidden')}
      aria-label={t('common.back')}
      title={t('common.back')}
      onClick={() => navigate(-1)}
      data-testid="voltar-no-cabecalho"
    >
      <ArrowLeft className="h-5 w-5" />
    </Button>
  );
}
